import React from 'react';

const DefaultQuestions = ({ categories, onQuestionClick, collapsed }) => {
  if (collapsed) return null;
  
  return (
    <div className="border-b border-gray-700 pb-4 mb-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {Object.entries(categories).map(([key, category]) => (
          <div key={key} className="space-y-2">
            <h4 className="text-sm font-medium text-gray-300 flex items-center gap-2">
              <span>{category.icon}</span>
              <span>{category.title}</span>
            </h4>
            <div className="space-y-1">
              {category.questions.map((question, idx) => (
                <button
                  key={idx}
                  onClick={() => onQuestionClick(question)}
                  className="w-full text-left text-xs px-3 py-2 rounded-lg
                           bg-gray-800/50 hover:bg-gray-700/70
                           text-gray-300 hover:text-white
                           transition-colors duration-150
                           border border-gray-700/50 hover:border-gray-600"
                  data-testid={`default-question-${key}-${idx}`}
                >
                  {question}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DefaultQuestions;
